import React, { useEffect, useState } from 'react';
import Logo from './Assets/rotating-logo.png';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Login from './Web Pages/Authentication/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import Verify from './Web Pages/Authentication/Verify';
import ModuleSelector1 from './Web Pages/Authentication/ModuleSelector1';
import AccountingDashboard from './Web Pages/Accoungting/AccountingDashboard';
import Remitance from './Web Pages/Accounting/Remitance/Remitance.js';
import LoanAccount from './Web Pages/Accounting/Loan Account/LoanAccount.js';
import Customer from './Web Pages/Accounting/Customer/Customer.js';
import 'react-loading-skeleton/dist/skeleton.css'
import ReportPage from './Web Pages/Accounting/Report/ReportPage.js';
import SuppliersAccount from './Web Pages/Accounting/Manage Suppliers Payables/Suppliers.js';
import Cashbook from './Web Pages/Accounting/Report/Cashbook.js';
import PrintCashbook from './Web Pages/Accounting/Print/PrintCashbook.js';
import MonthlyRemitance from './Web Pages/Accounting/MonthlyRemitance/MonthlyRemitance.js';
// import NewPayment from './Web Pages/Accounting/Payments/NewPayment.js';
import NewPaymentPage from './Web Pages/Accounting/Payments/NewPaymentPage.js';
import LoanBeneficiary from './Web Pages/Accounting/LoanBeneficiary/LoanBeneficiary.js';
import PurchaseInvoices from './Web Pages/Accounting/PurchaseInvoice/PurchaseInvoices.js';
import SupplierPersonal from './Web Pages/Accounting/Sales Invoice/SupplierPersonalLedgers.js';
import SchedulePayable from './Web Pages/Accounting/Schedule of Payables/SchedulePayable.js';
import StaffLoan from './Web Pages/Accounting/StaffLoan/StaffLoan.js';
import RepaymentSchedule from './Web Pages/Accounting/Repayment Schedule/RepaymentSchedule.js';
import CustomerLedger from './Web Pages/Accounting/Customer/CustomerLedger.js';
import NewPayablesPage from './Web Pages/Accounting/Payments/NewPayablesPage.js';
import Instruction from './Web Pages/Accounting/Payments/Instruction/Instruction.js';
import StaffLedger from './Web Pages/Accounting/StaffLedger/StaffLedger.js';
import CashReceipt from './Web Pages/Receipt/CashReceipt.js';
import PrintCashReceipt from './Web Pages/Accounting/Print/PrintCashReceipt.js';
import ReceiptRemitance from './Web Pages/Receipt/ReceiptRemitance.js';
import SuppliersLedger from './Web Pages/Accounting/SuppliersLedger/SuppliersLedger.js';
import Payee from './Web Pages/Accounting/SuppliersLedger/Payee.js';
import HmoPage from './Web Pages/Accounting/SuppliersLedger/Hmo.js';
import Pension from './Web Pages/Accounting/SuppliersLedger/Pension.js';
import UploadRemittanceModal from './Web Pages/Accounting/MonthlyRemitance/UploaRemitance.js';
import PrintCustomerLedger from './Web Pages/Accounting/CustomerLedger/PrintCustomerLedger.js';
import SuppliersPersonalLedger from './Web Pages/Accounting/SuppliersLedger/SuppliersPersonalLedger.js';
import CustomerPersonalLedger from './Web Pages/Accounting/CustomerLedger/CustomerPersonalLedger.js';
import LoanLedger from './Web Pages/Accounting/Loan Ledger/LoanLedger.js';
import PrintActivity from './Web Pages/Accounting/Print/PrintActivity.js';
import Paye from './Web Pages/Accounting/SuppliersLedger/Paye.js';
import Contractors from './Web Pages/Accounting/SuppliersLedger/Contractors.js';
import LoanDisbursement from './Web Pages/Accounting/Payments/LoanDisbursement.js';
import TrialBalance from './Web Pages/Accounting/Trial Balance/TrialBalance.js';
import ApprovedPayables from './Web Pages/Accounting/Payments/ApprovedPayables.js';
import PayablesPayment from './Web Pages/Accounting/Payments/PayablesPayment.js';
import JournalEntries from './Web Pages/Accounting/Payments/JournalEntries.js';
import PayablesEntries from './Web Pages/Accounting/Payments/PayablesEntries.js';
import ChartofAccount from './Web Pages/Accounting/ChartofAccount/ChartofAccount.js';
import IncomeStatement from './Web Pages/Accounting/Print/IncomeStatement.js';
import PrintOutstanding from './Web Pages/Accounting/Print/PrintOutstanding.js';
import LoanReceivables from './Web Pages/Accounting/PrintLoan/PrintLoans.js';
import PrintRemit from './Web Pages/Accounting/PrintLoan/PrintRemit.js';
import BankLodgement from './Web Pages/Receipt/BankLodgement.js';
import MakeJournal from './Web Pages/Accounting/Payments/MakeJournal.js';
import LodgedTransactions from './Web Pages/Receipt/LodgedTransactions.js';
import IncomeStatementDetailed from './Web Pages/Accounting/Print/IncomeStatementDetailed.js';
import FinancialPosition from './Web Pages/Accounting/Print Finanical Position/FinancialSummary.js';
import FinancialPositionDetailed from './Web Pages/Accounting/Print Finanical Position/FinancialSummaryDetailed.js';
import BankSummary from './Web Pages/Accounting/PrintBank/PrintBank.js';
import ScheduleofPayables from './Web Pages/Accounting/ScheduleofPayables/ScheduleofPayables.js';
import PrintRecievables from './Web Pages/Accounting/PrintAgeReport/PrintAgeReceivables.js';
import PrintPayables from './Web Pages/Accounting/PrintAgeReport/PrintPayables.js';
import JournalSearch from './Web Pages/Accounting/SearchJournal/JournalSearch.js';
import UploadBalance from './Web Pages/Accounting/Upload Journal/UploadBalance.js';
import BulkEntries from './Web Pages/Accounting/Upload Journal/UploadBalanceBulk.js';
import UploadEntry from './Web Pages/Accounting/Upload Journal/UploadEntry.js';
import PendingApproval from './Web Pages/Accounting/Approval/PendingAccount.js';
import DisapproveAccount from './Web Pages/Accounting/Approval/DIsapprovedAccount.js';
import SalesReport from './Web Pages/Accounting/Report/SalesReport.js';
import PurchaseReport from './Web Pages/Accounting/Report/PurchaseReport.js';
import CashReceiptss from './Web Pages/Accounting/Payments/CashManagement.js';
import CashMovement from './Web Pages/Accounting/Cash Movement/CashMovement.js';
import SalaryPayable from './Web Pages/Accounting/Payments/SalaryPayable.js';
import PrintCashReceipts from './Web Pages/Accounting/Print/PrintCashReceipts.js';
import ChequePay from './Web Pages/Accounting/Payments/ChequePayment.js';
import BankTransfer from './Web Pages/Accounting/Payments/BankTransfer.js';
import NewCheque from './Web Pages/Accounting/Payments/NewCheque.js';
import ReconciliationDashboard from './Web Pages/Reconciliation/ReconciliationDashboard.js';
import BankReconciliationNew from './Web Pages/Reconciliation/BankReconciliationNew.js';
import ReconciliationReport from './Web Pages/Accounting/Report/ReconciliationReport.js';
import ReconSummaryReport from './Web Pages/Accounting/Report/ReconSummaryReport.js';
import CashMovements from './Web Pages/Receipt/CashMovement/CashMovements.js';
import PaymentsUpload from './Web Pages/Accounting/Payments/PaymentsUpload.js';
import PaymentInstructions from './Web Pages/Accounting/SuppliersLedger/PaymentInstruction.js';
import NewChequePayment from './Web Pages/Accounting/Payments/NewChequePayment.js';
import InstructionFinal from './Web Pages/Accounting/Payments/Instruction/InstructionFinal.js';
import PaymentVoucher from './Web Pages/Accounting/Payments/PaymentVoucher/PaymentVoucher.js';
import UploadRemittance from './Web Pages/Accounting/Upload Remittance/UploadRemittance.js';
import ChartofaCcount from './Web Pages/Accounting/ChartofAccount/ChartofAccont.js';
import ChequePage from './Web Pages/Accounting/Payments/NewChequeTest.js';
import NewChequePays from './Web Pages/Accounting/Payments/NewChequePay.js';
import CashAdvanceReceipt from './Web Pages/Accounting/Cash Advance Receipt/CashAdvanceReceipt.js';
import NewProvidusCheque from './Web Pages/Accounting/Payments/NewProvidusCheque.js';
import NewZenithCheque from './Web Pages/Accounting/Payments/NewZenithCheque.js';
import ReconciliationKeyword from './Web Pages/Accounting/Report/ReconciliationKeyword.js';
import NewUBACheque from './Web Pages/Accounting/Payments/NewUBACheque.js';
import DefaultCheque from './Web Pages/Accounting/Payments/DefaultCheque.js';
import ManageParish from './Web Pages/FixedAssetReport/Fixed Asset Report/ManageParish.js';
import FixedReport from './Web Pages/FixedAssetReport/Report/ReportPage.js';
import ComplianceReport from './Web Pages/FixedAssetReport/Report/ComplianceReport.js';
import FixedAssetReport from './Web Pages/FixedAssetReport/Report/FixedReport.js.js';
import FixedUser from './Web Pages/FixedAssetReport/ManageUser/ProvincalUser.js';
import FixedAssetArea from './Web Pages/FixedAssetReport/Fixed Asset Report/FixedArea.js';
import ManageZones from './Web Pages/Manage Zones/ManageZones.js';
import ForgotPassword from './Web Pages/Authentication/ForgotPassword.js';
import ResetPassword from './Web Pages/Authentication/ResetPassword.js';
import PayableInstruction from './Web Pages/Accounting/SuppliersLedger/PayableInstruction.js';


import ParishReport from './Web Pages/FixedAssetReport/Fixed Asset Report/ParishReport.js';
import ViewFixedAsset from './Web Pages/FixedAssetReport/Fixed Asset Report/ViewFixedAsset.js';
import ViewAsset from './Web Pages/FixedAssetReport/Fixed Asset Report/ViewAssets.js';
import PrintFixedReport from './Web Pages/FixedAssetReport/Report/PrintFixedReport.js';
import AdminParish from './Web Pages/FixedAssetReport/Fixed Asset Report/AdminParish.js';
import AdminRegion from './Web Pages/FixedAssetReport/AdminRegion/AdminRegion.js';
import FixedAssetAdminUser from './Web Pages/FixedAssetReport/Config/FixedAssetAdminUser.js';
import FixedAssetContinent from './Web Pages/FixedAssetReport/Config/FixedContinent.js';
// import FixedAssetAdminParish from './Web Pages/FixedAssetReport/Config/AdminReport.js';
import ReportAdmin from './Web Pages/FixedAssetReport/Config/AdminReport.js';
import AdminViewAsset from './Web Pages/FixedAssetReport/Fixed Asset Report/AdminViewAsset.js';
import AdminProvince from './Web Pages/FixedAssetReport/AdminProvince/AdminProvince.js';
import FixedProvince from './Web Pages/FixedAssetReport/AdminProvince/FixedProvince.js';
import TransferReport from './Web Pages/FixedAssetReport/Report/TransferReport.js';
import PaymentBulk from './Web Pages/Accounting/Payments/PaymentBulk.js';
import PrintActivityCategory from './Web Pages/Accounting/Print/PrintActivityCategory.js';
import PayableCheque from './Web Pages/Accounting/PayableCheque.js';
import PayableNewInstruction from './Web Pages/Accounting/SuppliersLedger/PayableNewInstruction.js';



function App() {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setLoading(false);
          return 100;
        }
        return prev + 10;
      });
    }, 100);

    return () => clearInterval(timer);
  }, []);

  const LoadingScreen = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    {/* Rotating + pulsing logo */}
    <img
      src={Logo}
      alt="Loading..."
      style={{
        width: "150px",
        height: "auto",
        marginBottom: "20px",
        animation: "spinPulse 2s infinite linear",
      }}
    />

    {/* Progress bar */}
    <div
      style={{
        width: "200px",
        height: "4px",
        backgroundColor: "#e0e0e0",
        borderRadius: "2px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: `${progress}%`,
          height: "100%",
          background: '#174384',
          transition: "width 0.3s ease",
        }}
      ></div>
    </div>

    {/* Percentage text */}
    <div
      style={{
        marginTop: "10px",
        color: "#555",
        fontSize: "14px",
      }}
    >
      {progress}%
    </div>

    {/* Inline keyframes */}
    <style>
      {`
        @keyframes spinPulse {
          0%   { transform: rotate(0deg) scale(1); }
          50%  { transform: rotate(180deg) scale(1.1); }
          100% { transform: rotate(360deg) scale(1); }
        }
      `}
    </style>
  </div>
);


  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot_password" element={<ForgotPassword />} />
      <Route path="/reset_password" element={<ResetPassword />} />
     


      <Route path='/accounting/supplier' element={<SuppliersAccount />} />
      <Route path='/cheque_pageee_test' element={<ChequePage />} />
      <Route path='/accounting/cash_receipt' element={<CashReceipt />} />
      <Route path='/accounting/loan_ledger' element={<LoanLedger />} />
      <Route path='/accounting/receipt_remitance' element={<ReceiptRemitance />} />
      <Route path='/accounting/print_cash_receipt' element={<PrintCashReceipt />} />
      <Route path='/accounting/print_outstanding_remittances' element={<PrintOutstanding />} />
      <Route path='/accounting/print_activity_report_acct' element={<PrintActivity />} />
      <Route path='/accounting/print_activity_report_category' element={<PrintActivityCategory />} />
      <Route path='/accounting/purchase_invoices' element={<PurchaseInvoices/>} />
      <Route path='/accounting/suppliers_ledger' element={<SuppliersLedger/>} />
      <Route path='/accounting/customers_ledger' element={<CustomerLedger/>} />
      <Route path='/accounting/suppliers_personal_ledgers' element={<SuppliersPersonalLedger/>} />
      <Route path='/accounting/payable_entries' element={<PayablesEntries/>} />
      <Route path='/accounting/salary_payables_entries' element={<SalaryPayable/>} />
      <Route path='/accounting/print_personal_ledgers' element={<CustomerPersonalLedger/>} />
      <Route path='/accounting/print_income_statement' element={<IncomeStatement/>} />
      <Route path='/accounting/print_income_statement_detailed' element={<IncomeStatementDetailed/>} />
      <Route path='/accounting/paye' element={<Payee/>} />
      <Route path='/accounting/hmo' element={<HmoPage/>} />
      <Route path='/accounting/pension' element={<Pension/>} />
      <Route path='/accounting/paye_invoices' element={<Paye/>} />
      <Route path='/accounting/contractor_invoices' element={<Contractors/>} />
      <Route path='/accounting/suppliers_personal_ledger' element={<SupplierPersonal/>} />
      {/* <Route path='/accounting/schedule_of_payable' element={<SchedulePayable/>}/> */}
      <Route path='/account_payables_bulk' element={<NewPayablesPage/>}/>
      <Route path='/account_payables_payment' element={<PayablesPayment/>}/>
      <Route path='/account_approved_payables' element={<ApprovedPayables/>}/>
      <Route path='/print_payment_instruction' element={<PaymentInstructions/>}/>
      <Route path='/print_instructn' element={<Instruction/>}/>
      <Route path='/print_instructn_final' element={<InstructionFinal/>}/>
      <Route path='/account_payments' element={<NewPaymentPage/>}/>
      <Route path='/bulk_payment_entries' element={<PaymentBulk/>}/>
      <Route path='/account_payments_upload' element={<PaymentsUpload/>}/>
      <Route path='/accounting/view_journal_entries' element={<JournalEntries/>}/>
      <Route path='/accounting/new_journal_entries' element={<MakeJournal/>}/>
      <Route path='/account_loan_disbursement' element={<LoanDisbursement/>}/>

   
      {/* <Route path='/accounting/schedule_of_payable' element={<SchedulePayables/>}/> */}
      <Route path='/accounting/report' element={<ReportPage/>}/>
      <Route path='/accounting/upload_remitance_excel_new' element={<UploadRemittance/>}/>
<Route path='/payable_new_instruction' element={<PayableNewInstruction/>}/>

      <Route path="/otp_secure" element={<Verify />} />
      <Route path="/welcome" element={<ModuleSelector1 />} />
      <Route path="/accounting" element={<AccountingDashboard />} />
      <Route path="/accounting/loan_account" element={<LoanAccount />} />
      <Route path="/accounting/customers" element={<Customer />} />
      <Route path="/accounting/remitances" element={<Remitance/>} />
      <Route path="/accounting/cashbook" element={<Cashbook/>} />
      <Route path="/accounting/print_cashbook" element={<PrintCashbook/>} />

      <Route path="/accounting/upload_remitance_excel" element={<UploadRemittanceModal/>} />
      <Route path="/reconciliation_report" element={<ReconciliationReport/>} />
      <Route path="/reconciliation/reconciliation_keyword" element={<ReconciliationKeyword/>} />
      <Route path="/reconciliation/summary_report" element={<ReconSummaryReport/>} />
      <Route path="/accounting/display_remitance_excel" element={<MonthlyRemitance/>} />
      {/* <Route path="/accounting/upload_remitance_excel" element={<MonthlyRemitance/>} /> */}
      <Route path="/accounting/loan" element={<LoanBeneficiary/>} />
      <Route path="/accounting/receivables/staff_loan" element={<StaffLoan/>} />
      <Route path="/accounting/receivables/repayment_schedule" element={<RepaymentSchedule/>} />
     
      <Route path="/accounting/print_customer_ledger" element={<PrintCustomerLedger/>} />
      <Route path="/accounting/staff_personal_ledger" element={<StaffLedger/>} />
      <Route path="/accounting/charts_of_account/account" element={<ChartofaCcount/>} />
      <Route path="/accounting/charts_of_account/account_print" element={<ChartofAccount/>} />

      <Route path="/accounting/cash_movement" element={<CashMovement/>} />
      <Route path="/reconciliation" element={<ReconciliationDashboard/>} />
      <Route path="/accounting/bank_reconciliationnew" element={<BankReconciliationNew/>} />
     <Route path='/payable_instruction' element={<PayableInstruction/>}/>
      <Route path='/payable_cheque' element={<PayableCheque/>}/>
    
      <Route path="/print_payments" element={<NewCheque />} />
      <Route path="/default_cheque" element={<DefaultCheque />} />
      <Route path="/print_zenith_payments" element={<NewZenithCheque />} />
      <Route path="/print_uba_payments" element={<NewUBACheque />} />
      <Route path="/print_providus_payments" element={<NewProvidusCheque />} />
      {/* <Route path="/print_cheque_payments" element={<NewChequePayment />} /> */}
      <Route path="/print_cheque_payments" element={<NewChequePays />} />
      <Route path="/payment_instructions" element={<BankTransfer />} />
      <Route path="/cheque_payments" element={<ChequePay />} />
      <Route path="/accounting/purchase_report" element={<PurchaseReport />} />
      <Route path="/accounting/sales_report" element={<SalesReport />} />
      <Route path="/accounting/account_dispproved" element={<DisapproveAccount />} />
      <Route path="/accounting/account_approvals" element={<PendingApproval />} />
      <Route path="/accounting/upload_journal_entry" element={<UploadEntry />} />
      <Route path="accounting/upload_opening_balance_bulk" element={<BulkEntries />} />
      <Route path="/accounting/upload_opening_balance" element={<UploadBalance />} />
      <Route path="/accounting/search_account_journals" element={<JournalSearch />} />
      <Route path="/accounting/aged_analysis_payables" element={<PrintPayables />} />
      <Route path="/accounting/aged_analysis_receivables" element={<PrintRecievables />} />
      <Route path="/accounting/bank_report" element={<BankSummary />} />
      <Route path="/accounting/statement_of_financial_position" element={<FinancialPositionDetailed />} />
      <Route path="/financial_position" element={<FinancialPosition />} />
      <Route path="/accounting/trial_balance" element={<TrialBalance/>} />
      <Route path="/accounting/print_loan_receivables" element={<LoanReceivables/>} />
      <Route path="/accounting/print_outstanding_remittance" element={<PrintRemit/>} />
        <Route path="/cash_management/bank_lodgement/pending" element={<BankLodgement/>} />
         <Route path="/cash_management/lodged_transactions" element={<LodgedTransactions/>} />
         <Route path="/accounting/schedule_of_payable" element={<ScheduleofPayables/>} />
         <Route path="/cash_receipt" element={<CashReceiptss/>} />
         <Route path="/print_cash_receipts" element={<PrintCashReceipts/>} />
         <Route path="/accounting_cashmovement" element={<CashMovements/>} />
         <Route path="/payment-voucher" element={<PaymentVoucher/>} />
          <Route path="/accounting/cash_advances" element={<CashAdvanceReceipt />} />

          <Route path='/fixed_admin_asset_report' element={<ReportAdmin />} />
      <Route path='/fixed_asset_continent' element={<FixedAssetContinent />} />
      <Route path='/fixed_asset/admin_user' element={<FixedAssetAdminUser />} />
          <Route path="/fixed_asset_home" element={<ManageParish />} />
          <Route path="/fixed/asset/report" element={<FixedReport />} />
          <Route path="/fixed_asset_report" element={<FixedAssetReport />} />
          <Route path="/fixed_asset/print_report" element={<PrintFixedReport />} />
          <Route path="/fixed_compliance_report" element={<ComplianceReport />} />
          <Route path="/fixed_transfer_report" element={<TransferReport />} />
          <Route path="/fixed_asset/provincial_user" element={<FixedUser />} />
          <Route path="/fixed_asset/area" element={<FixedAssetArea />} />
          <Route path="/fixed_asset/zone" element={<ManageZones />} />
          <Route path="/fixed_asset/parish" element={<ParishReport />} />
          <Route path="/fixed_assets_registers" element={<ViewFixedAsset />} />
          <Route path="/view_asset" element={<ViewAsset />} />
          <Route path="/view_asset_report" element={<AdminViewAsset/>} />
          <Route path="/fixed_asset_admin_home" element={<AdminParish />} />
          <Route path="/fixed_asset_region" element={<AdminRegion />} />

          <Route path="/fixed_asset_province" element={<AdminProvince />} />
          {/* <Route path="/fixed_asset_province_test" element={<FixedProvince />} /> */}
    </Routes>
  );
}

export default App;
